module.exports = __webpack_public_path__ + "media/images/haircut/weinie@2x-9229c5db8bd5beb670579580cd46e7e2.jpg";